import _ from 'lodash';
import moment from 'moment';
import { getCurrentInstance } from 'vue';

export function useHelpers() {
  const getValInObj = (
    obj,
    slug,
    falsyValue = '',
    prefix = '',
    suffix = ''
  ) => {
    if ((!obj && typeof obj != 'object') || obj === null) return falsyValue;
    let result = _.cloneDeep(obj);
    const nests = slug.split('.');

    for (const nest of nests) {
      if (result[nest] === null || typeof result[nest] === 'undefined') {
        result = falsyValue;
        break;
      } else {
        result = result[nest];
      }
    }

    if (result !== falsyValue) {
      if (prefix) result = prefix + result;

      if (suffix) result = result + suffix;
    }

    return result;
  };

  const generateDateRange = (start, end) => {
    const steps = 1;
    const startDate = moment(start).format('YYYY-MM-DD');
    const endDate = moment(end).format('YYYY-MM-DD');

    const dateArray = [];
    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
      // dateArray.push(new Date(currentDate));
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
      // Use UTC date to prevent problems with time zones and DST
      currentDate.setUTCDate(currentDate.getUTCDate() + steps);
    }
    return dateArray;
  };

  const buildFormData = (formData, data, parentKey, allowEmpty = true) => {
    if (
      data &&
      typeof data === 'object' &&
      !(data instanceof Date) &&
      !(data instanceof File)
    ) {
      Object.keys(data).forEach((key) => {
        buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key,
          allowEmpty
        );
      });
    } else {
      const value = data == null ? '' : data;
      if ((!allowEmpty && value) || allowEmpty)
        formData.append(parentKey, value);
    }
    return formData;
  };
  const jsonToFormData = (data, allowEmpty = true) => {
    const result = buildFormData(new FormData(), data, false, allowEmpty);
    return result;
  };

  const isEmptyObj = (obj) => {
    for (const prop in obj) {
      if (obj[prop] !== undefined) return false;
    }
    return true;
  };

  const getVMInstance = (obj) => {
    const appInstance = getCurrentInstance();
    return appInstance?.appContext?.app?.config?.globalProperties;
  };

  const formatTime = (time) => {
    return time.format('mm') === '00' ? time.format('h') : time.format('h:mm');
  };

  const calendarFormatTimeRange = (startStr, endStr) => {
    const start = moment(startStr);
    const end = moment(endStr);

    const formattedStart = formatTime(start);
    const formattedEnd = formatTime(end);

    let meridiem = start.format('a');
    if (start.format('a') !== end.format('a')) {
      return `${formattedStart}${start.format('a')}-${formattedEnd}${end.format(
        'a'
      )}`;
    } else {
      return `${formattedStart}-${formattedEnd}${meridiem}`;
    }
  };

  return {
    calendarFormatTimeRange,
    getVMInstance,
    getValInObj,
    generateDateRange,
    jsonToFormData,
    isEmptyObj,
  };
}
